import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { MenuManagementBrandCategoryCreateParams } from '@/services/BrandCategory/hooks/create/useMenuManagementCreateBrandCategory';
import {
  CategoryListResponse,
  MenuManagementCategoryListParams,
} from '@/services/BrandCategory/hooks/list/useMenuManagementBrandCategoryList';
import { SearchCategoryParams } from '@/services/BrandCategory/hooks/search/useMenuManagementSearchBrandCategories';
import { ShowBrandCategoryResponse } from '@/services/BrandCategory/hooks/show/useMenuManagementBrandCategoryShow';
import { MenuManagementBrandCategoryUpdateParams } from '@/services/BrandCategory/hooks/update/useMenuManagementBrandUpdateCategory';
import { menuManagementListQueryParams } from '@/services/Service/MenuManagementList';

interface Interface {
  list: (
    params: MenuManagementCategoryListParams
  ) => Promise<CategoryListResponse>;
  search: (params: SearchCategoryParams) => Promise<SearchItem[]>;
  create: (params: MenuManagementBrandCategoryCreateParams) => Promise<void>;
  show: (id: string) => Promise<ShowBrandCategoryResponse>;
  update: (
    id: string,
    params: MenuManagementBrandCategoryUpdateParams
  ) => Promise<void>;
  delete: (id: string) => Promise<void>;
}
export class MenuManagementBrandCategoryService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(
    params: MenuManagementCategoryListParams
  ): Promise<CategoryListResponse> {
    const query = menuManagementListQueryParams(params);
    return await this.restClient.get<CategoryListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-categories${query}` as const
    );
  }

  public async create(
    params: MenuManagementBrandCategoryCreateParams
  ): Promise<void> {
    await this.restClient.post<MenuManagementBrandCategoryCreateParams, void>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-categories` as const,
      params
    );
  }

  public async search(params: SearchCategoryParams): Promise<SearchItem[]> {
    const query =
      `?associate_brand_id=${params.associate_brand_id.toString()}&title=${
        params.title
      }` as const;

    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-categories/search${query}` as const
    );
  }

  public async show(id: string): Promise<ShowBrandCategoryResponse> {
    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-categories/${id}` as const
    );
  }

  public async update(
    id: string,
    params: MenuManagementBrandCategoryUpdateParams
  ): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-categories/${id}` as const,
      params
    );
  }

  public async delete(id: string): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-categories/${id}` as const
    );
  }
}
